<template>
  <div>
    <section class="hero is-grey-ligth mainContent">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title has-text-dark">Datos</h1>
              <h2 class="subtitle has-text-dark">{{ subtitle }}</h2>
            </div>
          </div>
          <!-- <div class="columns">
            <div class="column">
              <div class="buttons">
                <button
                  v-for="(item, index) in carpetas"
                  :key="index"
                  class="button is-info is-inverted is-medium"
                  @click="selectfolder(item)"
                  v-bind:class="{ 'is-outlined': folderselect(item) }"
                >
                  <span class="icon">
                    <i v-show="folderselect(item)" class="material-icons">folder</i>
                    <i v-show="!folderselect(item)" class="material-icons">folder_open</i>
                  </span>
                  <span>{{item.nombre}}</span>
                </button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section mainContent">
      <div class="tabs topSubMenu">
        <ul
          class="selectedMenu"
          id="listdata"
          @click="navigateSelect('listdata', 'Lista')"
        >
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'datamenu.listdata' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Lista de datos</a>
            </li>
          </router-link>
        </ul>
        <ul
          id="listfrs"
          @click="
            navigateSelect(
              'listfrs',
              'Informes de Factores de Riesgo Psicosocial'
            )
          "
        >
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'datamenu.listfrs' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Datos FRS</a>
            </li>
          </router-link>
        </ul>
        <ul
          v-if="tokenUser.admin"
          id="uploaddata"
          @click="navigateSelect('uploaddata', 'Subir Datos')"
        >
          <router-link
            custom
            v-slot="{ navigate }"
            :to="{ name: 'datamenu.uploaddata' }"
          >
            <li @click="navigate" @keypress.enter="navigate" role="link">
              <a>Subir datos</a>
            </li>
          </router-link>
        </ul>
      </div>
      <div class="container">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      subtitle: "Lista",
    };
  },
  computed: {
    ...mapState(["tokenUser"]),
  },
  methods: {
    subTitle(s) {
      this.subtitle = s;
    },
    navigateSelect(name, s) {
      let ul = document.getElementsByTagName("ul");

      for (let i = 0; i < ul.length; i++) {
        ul[i].classList.remove("selectedMenu");
      }

      let ele = document.getElementById(name);
      ele.classList.add("selectedMenu");
      this.subTitle(s);
    },
  },
  created() {
    this.$router.push("datamenu/listdata");
  },
};
</script>
<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #07689f;
  color: #07689f;
}

.mainContent {
  padding: 0px 60px;
}

.topSubMenu {
  padding: 0px 60px;
  margin: 10px 0px 5px 0px;
}

.selectedMenu li a {
  color: #510087;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/data/DataMenu.vue